export const inputGroupTheme = {
  addon: {
    padding: '0 var(--half-rem)',
    minWidth: 'var(--trigger-icon-rem)',
    borderRadius: 'var(--border-radius)',
  },
  colorScheme: {
    light: {
      addon: {
        background: 'var(--white)',
        color: 'var(--text-color-secondary)',
      },
    },
    dark: {
      addon: {
        background: 'var(--p-surface-900)',
        color: 'var(--p-surface-400)',
      },
    },
  },
  css: ({ dt }: any) => `
    .agility-input-group .p-inputgroup > *:not(.p-inputgroupaddon) > .p-component,
    .agility-input-group .p-inputgroup > *:not(.p-inputgroupaddon) > .p-inputwrapper > .p-component {
      border-radius: 0;
      margin: 0;
    }

    .agility-input-group .p-inputgroup > *:not(.p-inputgroupaddon):first-child > .p-component,
    .agility-input-group .p-inputgroup > *:not(.p-inputgroupaddon):first-child > .p-inputwrapper > .p-component {
      border-start-start-radius: ${dt('inputgroup.addon.border.radius')};
      border-end-start-radius: ${dt('inputgroup.addon.border.radius')};
    }

    .agility-input-group .p-inputgroup > *:not(.p-inputgroupaddon):last-child > .p-component,
    .agility-input-group .p-inputgroup > *:not(.p-inputgroupaddon):last-child > .p-inputwrapper > .p-component {
      border-start-end-radius: ${dt('inputgroup.addon.border.radius')};
      border-end-end-radius: ${dt('inputgroup.addon.border.radius')};
    }

    .agility-input-group .p-inputgroupaddon p-button {
      height: 100%;
    }

    .agility-input-group .p-inputgroupaddon p-button > button {
      padding: 0;
    }
  `,
};
